// extracted by mini-css-extract-plugin
module.exports = {"base":"_3rjSAJ"};